import { render } from "./V1Switch.vue?vue&type=template&id=0f8f74d0&scoped=true&ts=true"
import script from "./V1Switch.vue?vue&type=script&lang=ts"
export * from "./V1Switch.vue?vue&type=script&lang=ts"

import "./V1Switch.vue?vue&type=style&index=0&id=0f8f74d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8f74d0"]])

export default __exports__